import MainApi from '@/scripts/api/main.api'
import Global from '@/scripts/Global'
import KeyboardManager from '@/Manager/keyboard.manager'
import { Logging } from '@/scripts/Logging';
import UserApi from '@/scripts/api/user.api';
import { CPUtils } from '@/scripts/Utils';
import VueSignals from '@/scripts/VueSignals';


export default {
    name: 'Login',
    data (){
        return {
          loggedIn: Global.isLoggedInCookie(),
          loading: false,
          rememberPW: false,
          error_message: "",
          user: {
              authenticated: false,
              email: '',
              password: ''
          },
          token: "",
          hasToken: false,
          session_id: '',
          hasEmail: false,
          email_error: false,
        }
      },
  mounted(){
    if(!this.loggedIn && !Global.getAlr()){
      Global.Splash(0);

      // if (Global.isMobileClientUsed()) {
      //     window.top.invokeCSharpRelogin(Global.GetPortalURL());
      // }
    }

    if(sessionStorage.getItem('invalid_session_id') != null){
      this.error_message = "You are logged out, Please try to login again"
    }

    if(Global.getLoginTokenCookie() != ''&&
        this.user.email == sessionStorage.getItem('login_email')){
        this.token = Global.getLoginTokenCookie()
        this.hasToken = true
        this.rememberPW  = true
        this.user.email = sessionStorage.getItem('login_email')
        this.user.password = "password"
    } else {
      this.rememberPW = false
    }
    KeyboardManager.disableChatMode()
  },
  methods: {
    rememberLogin(){
      this.rememberPW = !this.rememberPW
      if(this.rememberPW){
        sessionStorage.setItem('rememberPW', this.rememberPW)
        sessionStorage.setItem('login_email', this.user.email)
        sessionStorage.setItem('login_pw', "password")
      }
    },
    doLogin(){
      Global.Splash(1)
      this.loading = true
          if(this.hasToken){
            MainApi.authenticate(null, null, this.token).then(
              res => {
                if(res.data.result){
                    this.loggedIn = true
                    Global.globalValue(VueSignals.AUTHENTICATED, true)
                    Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                    Global.globalValue(VueSignals.SESSION_ID, res.data.session_id)
                    Global.globalValue('login_email', this.user.email)
                    Global.setSessionID(res.data.session_id)
                }else {
                  this.error_message = this.$t("Wrong pw or email")
                  Global.Splash(0)
                }
                this.loading = false
              }
            ).then(res => {
              if(this.rememberPW){
                UserApi.getLoginToken().then(res=> {
                  if(res.data.result){
                    let token = res.data.token_id
                    sessionStorage.setItem("login_token", token)

                  }
                })
              }
            }).catch(
              err => {
                Logging.Error(err)
              }
            )
        }else {
            Global.removeAllCookies()
            Global.Splash(1)
            MainApi.authenticate(this.user.email, this.user.password).then(
              res => {
                if(res.data.result){
                    this.loggedIn = true
                    Global.globalValue(VueSignals.AUTHENTICATED, true)
                    Global.globalValue(VueSignals.IS_LOGGEDIN_USER, true)
                    Global.globalValue(VueSignals.SESSION_ID, res.data.session_id)
                    Global.setSessionID(res.data.session_id)
                }else {
                  this.error_message = this.$t("Wrong pw or email")
                  Global.Splash(0)
                }
                this.loading = false
              }
            ).then(res => {
              if(this.rememberPw){
                UserApi.getLoginToken().then(res=> {
                  if(res.data.result){
                    let token = res.data.token_id
                    sessionStorage.setItem("login_token", token)

                  }
                })
              }
            }).catch(
              err => {
                Logging.Error(err)
              }
            )
          }
    },
    Validate(type){
      if(type == 'username'){
        if(!CPUtils.ValidateUsername(this.username) || this.username.length == 0){
          this.username_error = true
          this.error_message = "Please choose username, Username can't contain Special charachters like @  / \\ . $ or space"
        }else {
          this.username_error = false
          this.error_message = ''
        }
      }

      if(type == 'email'){
        if(this.user.email.length == 0){
          this.email_error = true
          this.error_message = "Please enter an email"
        }else {
          this.email_error = false
          this.error_message = ''
        }
      }

      this.mainSpinner = false
    },
  }
}
